import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Paper,
  Step,
  StepLabel,
  Stepper,
  Tooltip,
  Typography,
} from '@mui/material';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import React, { useState } from 'react';
import OrderAddresses from './OrderAddresses.jsx';
import OrderCreditNotes from './OrderCreditNotes.jsx';
import OrderDetailsSummary from './OrderDetailsSummary.jsx';
import OrderInvoices from './OrderInvoices.jsx';

const OrderDetails = (props) => {
  const { order, openDetails, orderDetails } = props;
  const [displayAddresses, setDisplayAddresses] = useState(false);

  const handleDisplayAddresses = () => {
    setDisplayAddresses(!displayAddresses);
  };

  const getSteps = () => {
    const baseSteps = [
      'Initiée',
      'Enregistrée',
      'En préparation',
      'En livraison',
    ];
    if (['Erreur', 'Refusée', 'Annulée'].includes(orderDetails?.status?.name)) {
      return [...baseSteps.slice(0, 2), 'Annulée', ...baseSteps.slice(2)];
    }
    if (orderDetails?.status?.code === 'WAITING_SC') {
      return [...baseSteps.slice(0, 2), 'En attente SC', ...baseSteps.slice(2)];
    }
    return baseSteps;
  };

  const defineStepDateBasedOnStatus = (step) => {
    const _status = orderDetails?.status?.name;
    const dates = orderDetails?.dates;
    let date = '';
    switch (step) {
      case 'Initiée':
        date = dates?.createdAt || '';
        break;
      case 'Enregistrée':
        date = dates?.approvedAt || '';
        break;
      case 'En attente SC':
        date = dates?.updatedAt || '';
        break;
      case 'En préparation':
        date = dates?.shippingDate || dates?.shippingDateDesired || '';
        break;
      case 'En livraison':
        date = dates?.deliveredAt || '';
        break;
      // case "Annulée":
      //   date = order?.cancel?.createdAt || "";
      //   break;
      default:
        date = '';
        break;
    }
    if (date?.length > 0) {
      const baseDate = new Date(date).toLocaleString('fr-FR', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      });

      // if (step === "Annulée") {
      //   const author = order?.cancel?.author
      //     ? `par ${order?.cancel?.author?.firstName} ${order?.cancel?.author?.lastName}`
      //     : "";
      //   const reason = order?.cancel?.reason?.name
      //     ? `\nMotif : ${order?.cancel?.reason?.name}`
      //     : "";
      //   return `${baseDate} ${author}${reason}`;
      // }

      return baseDate;
    }
    return '';
  };

  const defineStepName = (step) => {
    if (step === 'En livraison' && orderDetails?.status?.name === 'Livrée') {
      return 'Livrée';
    }
    if (
      step === 'En préparation' &&
      (orderDetails?.status?.name !== 'Envoyé au STO' ||
        orderDetails?.status?.name !== 'En cours de traitement STO')
    ) {
      return 'Préparée';
    }
    if (step === 'En attente SC') {
      return 'Attente SC';
    }
    return step;
  };

  const defineOrderStep = (status) => {
    switch (status) {
      case 'Validée':
      case 'En cours':
        return 1;
      case 'En attente SC':
      case 'Envoyé au STO':
      case 'En cours de traitement STO':
      case 'Traité par STO':
        return 2;
      case 'Prise en charge par TAV':
      case 'En cours de livraison':
        return 3;
      case 'Livrée':
        return 4;
      case 'Erreur':
      case 'Refusée':
      case 'Annulée':
      case 'Créée':
      default:
        return 0;
    }
  };

  return (
    <>
      <Paper elevation={12}>
        <Stepper
          activeStep={defineOrderStep(orderDetails?.status?.name)}
          sx={{ margin: 0, marginBottom: 2, paddingTop: 2 }}
        >
          {getSteps()?.map((step, i) => {
            const labelProps = {};
            if (step === 'Annulée') {
              labelProps.error = true;
            }
            if (step === 'En attente SC') {
              labelProps.sx = {
                '& .MuiSvgIcon-root': {
                  color: '#D4A713',
                },
              };
            }
            return (
              <Tooltip
                title={defineStepDateBasedOnStatus(step)}
                placement="top"
                key={i}
              >
                <Step>
                  <StepLabel {...labelProps}>{defineStepName(step)}</StepLabel>
                </Step>
              </Tooltip>
            );
          })}
        </Stepper>
        <Accordion elevation={6} disableGutters expanded={displayAddresses}>
          <AccordionSummary
            expandIcon={
              <ExpandMoreRoundedIcon onClick={handleDisplayAddresses} />
            }
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '95%',
              }}
            >
              <Typography
                component={'span'}
                noWrap={false}
                sx={{ fontSize: '0.95em' }}
              >
                Adresses et date d&apos;expédition
              </Typography>
              <Tooltip
                title={`L'adresse de livraison et la date d'expédition souhaitée sont modifiables dans la section "Actions / Commande". La modification est possible uniquement sur les commandes en attente SC. `}
              >
                <Typography
                  component={'span'}
                  noWrap={false}
                  sx={{ fontSize: '0.8em', color: 'rgba(0, 0, 0, 0.5)' }}
                >
                  Informations modifiables dans la section &quot;Actions /
                  commande&quot;
                </Typography>
              </Tooltip>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              {displayAddresses === true && (
                <>
                  <OrderAddresses
                    orderAddresses={[
                      { ...orderDetails?.addresses?.billing, type: 'billing' },
                      {
                        ...orderDetails?.addresses?.shipping,
                        type: 'shipping',
                      },
                    ]}
                    orderStatus={orderDetails?.status?.code}
                  />
                </>
              )}
              <>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginLeft: 2,
                    gap: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginLeft: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box sx={{ display: 'flex' }}>
                        <Typography variant="span">
                          Date d&apos;expédition
                        </Typography>
                      </Box>
                    </Box>
                    <Typography variant="span" sx={{ fontSize: 12 }}>
                      {!orderDetails?.dates?.shippingDate
                        ? "Aucune date d'expédition"
                        : format(
                            new Date(orderDetails?.dates?.shippingDate),
                            "'Le' dd/MM/yyyy",
                            { locale: fr }
                          )}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginLeft: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box sx={{ display: 'flex' }}>
                        <Typography variant="span">
                          Date d&apos;expédition souhaitée
                        </Typography>
                        {(orderDetails?.status?.code !== 'WAITING_SC' ||
                          orderDetails?.status?.code !== 'VALIDATED') && (
                          <Tooltip
                            title={
                              orderDetails?.status?.code !== 'WAITING_SC'
                                ? "Passez la commande en attente SC pour modifier la date d'expédition"
                                : "Modifier la date d'expédition souhaitée dans la section Actions / Commande"
                            }
                          >
                            <Box>
                              <InfoOutlinedIcon
                                fontSize="0.8em"
                                sx={{ ml: 1, cursor: 'help' }}
                              />
                            </Box>
                          </Tooltip>
                        )}
                      </Box>
                    </Box>
                    <Typography variant="span" sx={{ fontSize: 12 }}>
                      {!orderDetails?.dates?.shippingDateDesired
                        ? "Aucune date d'expédition souhaitée"
                        : format(
                            new Date(orderDetails?.dates?.shippingDateDesired),
                            "'Le' dd/MM/yyyy",
                            { locale: fr }
                          )}
                    </Typography>
                  </Box>
                </Box>
              </>
            </Box>
          </AccordionDetails>
        </Accordion>
        <OrderCreditNotes order={order} orderDetails={orderDetails} />
        <OrderInvoices orderDetails={orderDetails} />
        {orderDetails?.lines?.map((line, index) => {
          return (
            <OrderDetailsSummary
              key={index}
              line={line}
              order={order}
              openDetails={openDetails}
              orderDetails={orderDetails}
            />
          );
        })}
      </Paper>
    </>
  );
};

export default OrderDetails;
